import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { SHORT_DATE_FORMAT } from '../../constants';
import * as _ from '../../lodash';
import TimeSlot from './TimeSlot';

export default class TimeSlots extends Component {
  parseTimeSlots() {
    const { timeslots, availableDates, selectedDate, timeZone } = this.props;

    if (!timeslots.length) {
      return [];
    }

    const day = moment.tz(selectedDate, timeZone).format(SHORT_DATE_FORMAT);
    if (!availableDates.includes(day)) {
      return [];
    }

    const blockTimeSlot = _.find(timeslots, { date: day });
    return blockTimeSlot ? blockTimeSlot.timeslots.sort((x, y) => moment(y.start).isSameOrAfter(moment(x.start)) ? -1 : 1) : [];
  }

  render() {
    const {
      li,
      highlightColor,
      isDisplayRange,
      isShowRemainingSpace,
      onItemClick,
      timeZone,
      locale,
      timeFormat,
      selectedTimeSlot,
      quantity,
      minDate,
      maxDate,
    } = this.props;

    const now = moment.tz(timeZone);
    const minTime = minDate ? now.clone().add(minDate, 'seconds') : now.clone();
    const maxTime = maxDate ? now.clone().add(maxDate, 'days') : now.clone().add(2, 'years');
    const timeslots = this.parseTimeSlots();
    const slots = timeslots.map((timeslot) => {
      const start = moment.tz(timeslot.start, timeZone);
      const availableTimeSlot = timeslot.available >= quantity && start.isSameOrAfter(minTime) && start.isSameOrBefore(maxTime);
      let backgroundColor,
          border;
      if (li) {
        const color = highlightColor && highlightColor !== 'transparent' ? highlightColor : li.backgroundColorActive;
        backgroundColor = availableTimeSlot ? color || li.backgroundColorActive : li.backgroundColorInactive;

        if (JSON.stringify(timeslot) == JSON.stringify(selectedTimeSlot)) {
          border = li.borderSelected
        }
      }

      return (
        <li key={timeslot.start} style={{ background: backgroundColor, border: border }}>
          <TimeSlot
            disabled={!(availableTimeSlot)}
            className={availableTimeSlot ? '' : 'disable'}
            onClick={(event) => {
              onItemClick(timeslot, event);
            }}
            start={moment(timeslot.start)}
            finish={moment(timeslot.finish)}
            isDisplayRange={isDisplayRange}
            isShowRemainingSpace={isShowRemainingSpace}
            availableSpace={timeslot.available}
            timeZone={timeZone}
            timeFormat={timeFormat}
            quantity={quantity}
          />
        </li>
      );
    });
    return <ul>{slots}</ul>;
  }
}

TimeSlots.propTypes = {
  timeslots: PropTypes.array,
  timeZone: PropTypes.string,
  locale: PropTypes.string,
  isDisplayRange: PropTypes.bool,
  isShowRemainingSpace: PropTypes.bool,
  availableDates: PropTypes.array,
  li: PropTypes.object,
  highlightColor: PropTypes.string,
  timeFormat: PropTypes.string,
  selectedDate: PropTypes.any,
  onItemClick: PropTypes.func,
};
